import { type ConfigureStoreOptions, configureStore } from '@reduxjs/toolkit'
import { middlewares, queryReducers } from 'mmfintech-card-commons'
import thunk from 'redux-thunk'

export const createStore = (options?: ConfigureStoreOptions['preloadedState'] | undefined) =>
  configureStore({
    reducer: queryReducers,
    middleware: getDefaultMiddleware => getDefaultMiddleware().concat(middlewares.apiMiddleware).concat(thunk),
    ...options
  })

export const store = createStore()

export type RootState = ReturnType<typeof store.getState>
export type AppStore = ReturnType<typeof createStore>

export type AppDispatch = AppStore['dispatch']
